import type { BasePagingResponse } from "../../../lib/api-contract";
import { apiUtils } from "../../../utils/apiUtils";
import {
  BusinessCategory,
  BusinessProfileApiResponse,
  BusinessProfileRawApiResponse,
  BusinessProfileUIState,
  BusinessProfileUpdateRequest,
  Organization,
  OrganizationItemRawApiResponse,
  mapOrganizationItemToOrganization,
  mapRawApiResponseToApiResponse,
  mapUIToUpdateRequest,
} from "./BusinessProfile.data";

export const fetchBusinessProfile = async (
  signal?: AbortSignal,
): Promise<BusinessProfileApiResponse> => {
  const rawData = await apiUtils.getData<BusinessProfileRawApiResponse>(
    "/v1/local-merchant/business-profile",
    "Failed to fetch business profile",
    { signal },
  );
  return mapRawApiResponseToApiResponse(rawData);
};

export const fetchBusinessCategories = async (): Promise<BusinessCategory[]> => {
  return apiUtils.getData<BusinessCategory[]>(
    "/v1/category/merchant",
    "Failed to fetch business categories",
  );
};

export const fetchOrganizations = async (signal?: AbortSignal): Promise<Organization[]> => {
  const response = await apiUtils.getData<BasePagingResponse<OrganizationItemRawApiResponse>>(
    "/v1/auth/organizations",
    "Failed to fetch organizations",
    { signal },
  );
  return [...(response.list ?? [])].map(mapOrganizationItemToOrganization);
};

export const updateBusinessProfile = async (
  uiData: BusinessProfileUIState,
): Promise<BusinessProfileApiResponse> => {
  const updateRequest: BusinessProfileUpdateRequest = mapUIToUpdateRequest(uiData);
  const rawData = await apiUtils.putData<
    BusinessProfileRawApiResponse,
    BusinessProfileUpdateRequest
  >(
    "/v1/local-merchant/business-profile",
    updateRequest,
    "Failed to update business profile",
  );
  return mapRawApiResponseToApiResponse(rawData);
};

export const uploadBusinessLogo = async (file: File): Promise<{ logo_url: string }> => {
  // TODO: Implement when upload API is available
  // const formData = new FormData();
  // formData.append('logo', file);
  // const response = await api.post<BaseResponse<{ logo_url: string }>>('/v1/merchant/local-merchant/business-profile/logo', formData, {
  //     headers: {
  //         'Content-Type': 'multipart/form-data',
  //     },
  // });
  // return response.data.data;
  throw new Error("Upload logo API not yet implemented");
};
